import { useCurrentModule } from '../components';
import { useSwitchFlows } from './useSwitchFlows';
export const CYCLE_RECOMMENDATION_SPEC = 'recommendedCycleTest';
export const CYCLE_RECOMMENDATION_MOBILE_SPEC = 'recommendedCycleMobile';
const MOBILE_MODULE_NAME = 'eclipse-package-picker-mobile-module';
export const useCycleRecommendationEnabled = () => {
  const module = useCurrentModule();
  const {
    isQuickPayLightbox
  } = module.internals.useContext();
  const {
    ready,
    experiments
  } = module.internals.experiments.hooks.useExperiments();
  const {
    isSwitchFlow,
    isLoading: isSwitchFlowLoading
  } = useSwitchFlows();
  const spec = module.moduleName === MOBILE_MODULE_NAME ? CYCLE_RECOMMENDATION_MOBILE_SPEC : CYCLE_RECOMMENDATION_SPEC;
  const isLoading = ready === false || isSwitchFlowLoading;
  return {
    isEligible: !isLoading && isSwitchFlow === false && !isQuickPayLightbox && experiments.isEnabled(spec),
    isLoading
  };
};
//# sourceMappingURL=useCycleRecommendationEnabled.js.map